<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Label Reviews</h3>
          <div class="card-tools">
            <span class="badge badge-primary">{{ reviewsData.total || 0 }} total</span>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style="width: 80px">ID</th>
                  <th style="width: 200px">User</th>
                  <th>OCR Text</th>
                  <th>Response</th>
                  <th style="width: 180px">Created</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let review of reviews">
                  <td>{{ review.label_review_id }}</td>
                  <td>
                    <a *ngIf="review.user" [routerLink]="['/user', review.user.user_id]">
                      {{ getUserDisplay(review.user) }}
                    </a>
                    <span *ngIf="!review.user" class="text-muted">Unknown</span>
                  </td>
                  <td>
                    <div *ngIf="review.ocr_text">
                      <div *ngIf="!expandedOcr[review.label_review_id]">
                        {{ truncateText(review.ocr_text, 200) }}
                        <a *ngIf="review.ocr_text.length > 200" 
                           href="javascript:void(0)" 
                           (click)="toggleOcr(review.label_review_id)"
                           class="text-primary ml-2">
                          Show more
                        </a>
                      </div>
                      <div *ngIf="expandedOcr[review.label_review_id]">
                        <pre class="mb-0" style="max-height: 300px; overflow-y: auto;">{{ review.ocr_text }}</pre>
                        <a href="javascript:void(0)" 
                           (click)="toggleOcr(review.label_review_id)"
                           class="text-primary">
                          Show less
                        </a>
                        <button class="btn btn-sm btn-outline-secondary ml-2" 
                                (click)="copyToClipboard(review.ocr_text)">
                          <i class="fa fa-copy"></i> Copy
                        </button>
                      </div>
                    </div>
                    <span *ngIf="!review.ocr_text" class="text-muted">No OCR text</span>
                  </td>
                  <td>
                    <div *ngIf="review.parsedResponse">
                      <div *ngIf="!expandedJson[review.label_review_id]">
                        <div class="mb-1">
                          <strong>{{ review.parsedResponse.data?.title || 'No title' }}</strong>
                        </div>
                        <div class="small text-muted">
                          Score: {{ review.parsedResponse.ui?.score?.total || 'N/A' }}
                        </div>
                        <a href="javascript:void(0)" 
                           (click)="toggleJson(review.label_review_id)"
                           class="text-primary">
                          Show full JSON
                        </a>
                      </div>
                      <div *ngIf="expandedJson[review.label_review_id]">
                        <pre class="mb-0" style="max-height: 400px; overflow: auto; background: #f4f4f4; padding: 10px; border-radius: 4px;">{{ formatJson(review.parsedResponse) }}</pre>
                        <a href="javascript:void(0)" 
                           (click)="toggleJson(review.label_review_id)"
                           class="text-primary">
                          Hide JSON
                        </a>
                        <button class="btn btn-sm btn-outline-secondary ml-2" 
                                (click)="copyToClipboard(formatJson(review.parsedResponse))">
                          <i class="fa fa-copy"></i> Copy JSON
                        </button>
                      </div>
                    </div>
                    <div *ngIf="!review.parsedResponse">
                      <pre class="mb-0" style="max-height: 200px; overflow: auto;">{{ review.response_json }}</pre>
                    </div>
                  </td>
                  <td>
                    <small>{{ review.created_at | date:'short' }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mt-3" *ngIf="reviewsData.last_page > 1">
            <div class="col-12">
              <nav>
                <ul class="pagination justify-content-center">
                  <li class="page-item" [class.disabled]="page <= 1">
                    <a class="page-link" href="javascript:void(0)" (click)="loadReviews(page - 1)">Previous</a>
                  </li>
                  <li class="page-item active">
                    <span class="page-link">Page {{ page }} of {{ reviewsData.last_page }}</span>
                  </li>
                  <li class="page-item" [class.disabled]="page >= reviewsData.last_page">
                    <a class="page-link" href="javascript:void(0)" (click)="loadReviews(page + 1)">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>